import { SnackbarProvider } from "notistack";
import React from "react";
import PropTypes from "prop-types";
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
/**
 *
 * Component Which provides application level Notification handling
 *
 * Usage Example:
 *
 * Use with Hooks:
 *   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
 *
 * Use with Class Components:
 *
 *   withSnackBar(Component)
 *
 * options:
 *
 * snackbar:
 *  Refer https://iamhosseindhv.com/notistack (This component is just a wrapper)
 *
 *
 * @param props
 * @returns {*}
 * @constructor
 */
function NotificationProvider(props) {
    const { maxSnack, children } = props;
    const notistackRef = React.createRef();
    const onClickDismiss = key => () => {
        notistackRef.current.closeSnackbar(key);
    }

    return (
        <SnackbarProvider
            maxSnack={maxSnack}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            ref={notistackRef}
            action={(key) => (
                <Button onClick={onClickDismiss(key)}>
                    <CloseIcon />
                </Button>
            )}
        >
            {children}
        </SnackbarProvider>
    );
}

// NotificationProvider.Proptypes = {
//     /**
//      * Max No of Snackbars that can appear at a time
//      */
//     maxSnack: PropTypes.number,
//     /**
//      * The Child Components to wrap under this provider
//      */
//     children: PropTypes.node.isRequired,
// };

NotificationProvider.defaultProps = {
    maxSnack: 1,
};

export default NotificationProvider;
